import { BaseModel, RisorsaZund } from './_Index';
import {TipoRisorsa} from './generated/tipo-risorsa'

export enum CheckLottoMateriaMode {
    AccettaTutto = 0,
    SoloLottoPianificato = 1,
    NotificaLottoPianificato = 2
}

export class Risorsa extends BaseModel {
    reparto: string;
    organizzazioneId: number;
    formato: string;
    indirizzoIp: string;
    indirizzoIp2?: string;
    username?: string;
    password?: string;
    inputMask?: string;
    continuousLaunch: boolean;
    /** Feature 155: maschera di bit degli stati scritti sulla macchina (`null` = PIANIFICATO + LANCIATO). */
    statiScrittura?: number | null;
    continuousSend: boolean;
    condition: number;
    stato?: number;
    zund?: RisorsaZund;
    odlEnd?: number;
    odlStart?: number;
    odlPause?: number;
    trasfMagMode?: number;
    codMagazzino?: string;
    codMagArea?: string;
    codMagNc?: string;
    codMagAreaNc?: string;
    codMagScarti?: string;
    codMagAreaScarti?: string;
    codMagMateria?: string;
    codMagAreaMateria?: string;
    magUdM?: string;
    avanzaMode: number;
    scartoMode?: number;
    generaBox?: number;
    avanzaBoxMateriale?: boolean;
    tipoRisorsa: TipoRisorsa;
    printerId?: number;
    reportName?: string;
    reportNameScarto?: string;
    reportNameNc?: string;
    lineaNum?: number;
    printerApiUrl?: string;
    boxFormato?: number;
    consumoParziale?: boolean;
    checkLottoMateria?: number;
    portainerApiUrl?: string;
    portainerApiKey?: string;
    stackName?: string;
    executedBy?: string;
    classe?: string;
    imageUrl?: string;
    apiBaseUrl?: string;
    apiChiavePubblica?: string;
    apiChiavePrivata?: string;
    apiSandboxAuth?: boolean;
    giacenzaUdM1?: number;
    giacenzaUdM2?: number;
}
